import { gql } from "@apollo/client";

export const RECHAZO_MASIVO = gql`
mutation RechazoPrecioMasivo($input: [Int!]!) {
  rechazoPrecioMasivo(input: $input) {
    success,
    error,
    valorEsperado
  }
}`;